import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { Permissions, security } from "Common/permissions";
import size from "lodash/size";
import { connect } from "react-redux";
import { TAB } from "./constants";
import DocumentsSidebarMenu from "./documentsSidebarMenu";
import { actionCreators, getActiveDocumentId, getActiveDocumentType, getDocuments, getIsExpanded, getProjectId, getSelectedDocumentIds, getSelectedMethods, getTab } from "./redux";
const canViewTasks = security.isAllowed([Permissions.TasksView]);
const canViewMethods = security.isAllowed([Permissions.MethodsView]);
const canViewScripts = security.isAllowed([Permissions.MethodsView]);
const mapStateToProps = (state) => ({
    isExpanded: getIsExpanded(state),
    tabKey: getTab(state),
    sidebarMenuTabsRows: getTab(state) === TAB.METHODS && size(getSelectedMethods(state)) !== 0 ? 3 : 2,
    documentType: getActiveDocumentType(state),
    canViewTasks,
    canViewMethods,
    canViewScripts,
    projectId: getProjectId(state),
    selectedDocumentIds: getSelectedDocumentIds(state),
    activeDocumentId: getActiveDocumentId(state),
    documents: getDocuments(state)
});
const mapDispatchToProps = (dispatch) => ({
    onDocumentTypeChanged: documentType => {
        if (documentType !== DOCUMENT_TYPE.TABLE)
            dispatch(actionCreators.setTab(TAB.NAVIGATION));
    },
    onChangeDocumentType: (documentId, selectedType) => dispatch(actionCreators.setDocumentType(documentId, selectedType)),
    onExpandedChanged: isExpanded => dispatch(actionCreators.setIsExpanded(isExpanded))
});
export default connect(mapStateToProps, mapDispatchToProps)(DocumentsSidebarMenu);
